// Stockholders Vuex

import state from './stockholdersStates.js'
import * as getters from './stockholdersGetters.js'
import * as mutations from './stockholdersMutations.js'
import * as actions from './stockholdersActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
